module.exports = __webpack_public_path__ + "static/img/40018 (3).d68e77e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40018 (3).webp
// module id = OdSU
// module chunks = 14